export default __webpack_public_path__ + "static/media/checking calculator 2.d20f7d6e.png";